module.exports = __webpack_public_path__ + "img/warning.c728ba75.svg";